import {ChangeDetectionStrategy, Component, Input, OnInit} from '@angular/core';
import {NbDialogRef} from "@nebular/theme";
import {IContradiction} from "../../../../../shared/models/contradiction.model";

@Component({
  selector: 'app-user-transaction-reconciliation',
  templateUrl: './reconciliation-user-transaction.component.html',
  styleUrls: ['./reconciliation-user-transaction.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ReconciliationUserTransactionComponent implements OnInit {
  @Input() allContradiction!: IContradiction[]

  constructor(private dialogRef: NbDialogRef<any>) {
  }

  ngOnInit(): void {
  }

  closeDialog(): void {
    this.dialogRef.close();
  }

}
